import React from "react";
import './style.css'

const MatchCard = ({match})=>{
    const renderTimeLabel = ()=>{
        if(match?.resultado && match?.resultado !== '-'
) return <div className="container-match-card-from-list-item-schudule">
    <p >{match?.penales ? `Penales: ${match?.penales}` : ''}</p>
    <p className="container-match-card-from-list-item-schudule-tag-finish" style={{backgroundColor: match?.hasFinish ? 'red' : '', borderRadius:'3px'}}>{match?.tiempo}</p>
    <p style={{fontWeight:'bold'}} >{match?.resultado}</p>
        </div>

        return(
                                <div className="container-match-card-from-list-item-time" >
                                        <p className="container-match-card-from-list-item-time-tag-vs" >vs</p>
                                        <p className="container-match-card-from-list-item-time-tag-time" >{match?.horario}</p>
                                    </div>

        )
    }





    return(             <div className="container-match-card-from-list">
                                    <div className="container-match-card-from-list-item-team" >
                                        <p >{match?.['equipoLocal']?.name}</p>
                                        <img  src={match?.['equipoLocal']?.pictureTeam} />

                                    </div>
                                    {
                                        renderTimeLabel()
                                    }

                                    <div className="container-match-card-from-list-item-team">
                                        <img  src={match?.['equipoVisitante']?.pictureTeam} />

                                         <p>{match?.['equipoVisitante']?.name}</p>

                                    </div>
                                </div>)
}

export default MatchCard